import * as previewLogics from '../../../preview/logics';

import { API_EDIT_LOGO, logoEditingStatusEnum, sidebarTabKeyEnum, undoRedoType } from '../../../utils/constants';
import {
  changeLogoEditingStatus,
  hideWaitingCover,
  removeTempBackgroundImage,
  showMessageBox,
  showWaitingCover,
  updateTempBackgroundImage,
} from '../../../main/actions';

import { addBackgroundImage } from '../../../canvas/actions';
import { changeNextgenUiStatus } from '../../../nextgen/actions';
import { changeSidebarTabKey } from '../../../sidebar/actions';
import { checkBackgroundImageDpi } from '../../../canvas/logics';
import { consoleLog } from '../../../canvas/logics';
import { isMobileOnly } from 'react-device-detect';
import { nextGenFlyoutPanelEnum } from '../../../nextgen/constants';
import { post } from '../../../utils/request';
import { pushToUndoList } from '../../../canvas/components/UndoRedo/logic';
import templateDomain from '../../../template';

export const applyCropBackground = (params) => {
  const cropX = params.cropParameter ? Math.round(params.cropParameter.x / params.resizeRatio) : 0;
  const cropY = params.cropParameter ? Math.round(params.cropParameter.y / params.resizeRatio) : 0;
  const cropWidth = params.cropParameter ? Math.round(params.cropParameter.width / params.resizeRatio) : 0;
  const cropHeight = params.cropParameter ? Math.round(params.cropParameter.height / params.resizeRatio) : 0;

  let isCropped = false;
  if (cropWidth > 0 && cropHeight > 0) isCropped = true;

  if (params.itemUseScene7Template) {
    const cropRect = { x: cropX, y: cropY, width: cropWidth, height: cropHeight };
    const finalCropRect = {
      x: params.backgroundImage.data.autoCropRect.x + cropX,
      y: params.backgroundImage.data.autoCropRect.y + cropY,
      width: cropWidth,
      height: cropHeight,
    };

    const backgroundImageData = {
      ...params.backgroundImage.data,
      cropRect,
      finalCropRect,
      width: finalCropRect.width,
      height: finalCropRect.height,
    };
    params.dispatch(updateTempBackgroundImage(backgroundImageData));
    return;
  }

  const apiString =
    API_EDIT_LOGO +
    '/CropBackgroundImage' +
    '?vendorId=' +
    params.vendorId +
    '&allowBlank=' +
    params.allowBlank +
    '&isCropped=' +
    isCropped +
    '&cropX=' +
    cropX +
    '&cropY=' +
    cropY +
    '&cropWidth=' +
    cropWidth +
    '&cropHeight=' +
    cropHeight;

  post(apiString, [params.backgroundImage.data, params.backgroundImageOrigin.data])
    .then((res) => {
      const newBackgroundImage = res.data;
      params.dispatch(addBackgroundImage({ canvasKey: params.canvasKey, backgroundImageData: newBackgroundImage }));
      params.dispatch(hideWaitingCover());
    })
    .catch((err) => {
      consoleLog(err);
      params.dispatch(hideWaitingCover());
      params.dispatch(showMessageBox(err.message));
    });

  params.dispatch(showWaitingCover());
};

export const editBackgroundFinalize = (dispatch, canvasKey, customTemplate, newBackgroundImage, canvasData) => {
  const newBackgroundImageData = newBackgroundImage.data;
  if (newBackgroundImageData.cropWidth > 0 && newBackgroundImageData.cropHeight > 0 && canvasData) {
    const isLowDpi = checkBackgroundImageDpi({
      dispatch: dispatch,
      returnStatus: logoEditingStatusEnum.None,
      canvasData: canvasData,
      imageData: newBackgroundImage,
      isCropBackground: true,
    });
    if (isLowDpi) return;
  }

  dispatch(addBackgroundImage({ canvasKey, backgroundImageData: newBackgroundImageData }));
  dispatch(removeTempBackgroundImage());
  dispatch(changeLogoEditingStatus(logoEditingStatusEnum.None));
  dispatch(templateDomain.actions.selectCategory(canvasKey, customTemplate.categoryId));
  dispatch(templateDomain.actions.selectTemplate(canvasKey, customTemplate.categoryId, customTemplate.templateId));
  dispatch(previewLogics.updateFullPreview());
  if (isMobileOnly) dispatch(changeSidebarTabKey(sidebarTabKeyEnum.WhatsNext));
  dispatch(pushToUndoList(undoRedoType.UploadBackground));
  dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.BackgroundPanel } }));
};
